import CustomIcon from './CustomIcon'
import black from '../../../assets/img/icons/eagle-view.black.svg'
import white from '../../../assets/img/icons/eagle-view.white.svg'

const EagleViewIcon = (props: any) => {
    return (
        <CustomIcon
            light={black}
            dark={white}
            size={props.size} />
    );
};

export default EagleViewIcon;